<template>
  <div
    v-if="visible"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    @click.self="handleClose"
  >
    <div class="bg-white rounded-lg border border-gray-200 shadow-lg mx-4" :class="maxWidthClass">
      <div v-if="hasHeader" class="flex justify-between items-center mb-4 px-6 pt-6">
        <h3 class="text-lg md:text-xl font-semibold" v-if="title">{{ title }}</h3>
        <button
          v-if="showClose"
          class="text-textSub text-xl cursor-pointer"
          @click="handleClose"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="px-6 pb-6 pt-2">
        <slot />
      </div>
      <div v-if="$slots.footer" class="px-6 pb-6 pt-0">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    showClose: { type: Boolean, default: true },
    maxWidth: { type: String, default: 'md' }
  },
  computed: {
    hasHeader () {
      return this.title || this.showClose
    },
    maxWidthClass () {
      var map = {
        sm: 'max-w-md w-full',
        md: 'max-w-md w-full',
        lg: 'max-w-lg w-full',
        xl: 'max-w-2xl w-full'
      }
      return map[this.maxWidth] || map.md
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>

